import { Route, Router, Switch } from "wouter";
import { CheckinDeviceView } from "@/views/device/checkin-device.view";
import { CheckoutConsumableView } from "@/views/consumable/checkout-consumable.view";
import { CheckinConsumableView } from "@/views/consumable/checkin-consumable.view";
import { BookinDeviceView } from "@/views/device/bookin/bookin-device.view";
import { CheckoutDeviceView } from "@/views/device/checkout-device.view";
import { SearchDeviceView } from "@/views/device/search-device.view";
import { FrontpageView } from "@/views/frontpage.view";
import { SettingsView } from "@/views/settings.view";
import { ConsumablesTableView } from "@/views/consumable/consumables-table.view";
import { LocationChangeView } from "@/views/location-change/location-change.view";

export function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={FrontpageView} />
        <Route path="/checkout/device" component={CheckoutDeviceView} />
        <Route path="/checkout/consumable" component={CheckoutConsumableView} />
        <Route path="/checkin/device" component={CheckinDeviceView} />
        <Route path="/checkin/consumable" component={CheckinConsumableView} />
        <Route path="/bookin/device" component={BookinDeviceView} />
        <Route path="/search/device" component={SearchDeviceView} />
        <Route path="/location-change" component={LocationChangeView} />
        <Route path="/settings" component={SettingsView} />
        <Route path="/consumables" component={ConsumablesTableView} />
        <Route component={FrontpageView} />
      </Switch>
    </Router>
  );
}
